import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

import { forgotCredentialsTranslations as frt, sharedTranslations, signInTranslations } from 'translations';
import { isCRC168Enabled } from 'featureFlags';
import { ClientContext, LanguageContext } from 'providers';
import { FORGOT_TYPES } from 'common/constants/enums';

import './style.scss';

const ForgotCredentialsLinks = ({ onForgotCredentials }) => {
    const intl = useIntl();
    const {
        extensions: { allowForgotUsername },
    } = useContext(ClientContext);

    const { language } = useContext(LanguageContext);

    return (
        <div className="onsolve-forgot-credentials-section">
            {language?.lcId !== 'fr_CA' && (
                <>
                    <FormattedMessage {...signInTranslations.ng_signIn_forgot} />
                    &nbsp;
                </>
            )}
            {allowForgotUsername && (
                <>
                    <button
                        type="button"
                        alt="forgotUsername"
                        onClick={onForgotCredentials(FORGOT_TYPES.FORGOT_USERNAME)}
                        className="onsolve-forgot-credentials-section__link btn btn-link p-0 border-0"
                        id="forgot-username-button"
                        aria-label={
                            isCRC168Enabled() ? intl.formatMessage(frt.ng_forgotCredentials_forgotUsername) : undefined
                        }
                    >
                        <FormattedMessage {...sharedTranslations.ng_generic_username} />
                    </button>
                    &nbsp;
                    <FormattedMessage {...signInTranslations.ng_signIn_or} />
                    &nbsp;
                </>
            )}
            <button
                type="button"
                alt="forgotPassword"
                onClick={onForgotCredentials(FORGOT_TYPES.FORGOT_PASSWORD)}
                className="onsolve-forgot-credentials-section__link btn btn-link p-0 border-0"
                id="forgot-password-button"
                aria-label={isCRC168Enabled() ? intl.formatMessage(frt.ng_forgotCredentials_forgotPassword) : undefined}
            >
                <FormattedMessage {...sharedTranslations.ng_generic_password} />
            </button>
            {language?.lcId === 'fr_CA' && (
                <span className="ml-1">
                    <FormattedMessage {...signInTranslations.ng_signIn_forgot} />
                </span>
            )}
            ?
        </div>
    );
};

ForgotCredentialsLinks.propTypes = {
    onForgotCredentials: PropTypes.func,
};

export default ForgotCredentialsLinks;
